import { render, staticRenderFns } from "./BindPhone_Mingyueye.vue?vue&type=template&id=b3d8ec0c"
import script from "./BindPhone_Mingyueye.vue?vue&type=script&lang=js"
export * from "./BindPhone_Mingyueye.vue?vue&type=script&lang=js"
import style0 from "./BindPhone_Mingyueye.vue?vue&type=style&index=0&id=b3d8ec0c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports